/** Keep rules in sync with [services/passwordPolicy.ts](../../../services/passwordPolicy.ts) */
export const MIN_NEW_PASSWORD_LENGTH = 8;

export const minNewPasswordMessage = `Password must be at least ${MIN_NEW_PASSWORD_LENGTH} characters long`;
export const PASSWORD_REQUIRE_DIGIT_MESSAGE = 'Password must include at least one number';
export const PASSWORD_REQUIRE_SYMBOL_MESSAGE = 'Password must include at least one symbol';

const hasDigit = (s: string) => /\d/.test(s);
const hasSymbol = (s: string) => /[^A-Za-z0-9\s]/.test(s);

export function newPasswordPolicyError(password: unknown): string | null {
  if (password == null || typeof password !== 'string') return 'Password is required';
  if (password.length < MIN_NEW_PASSWORD_LENGTH) return minNewPasswordMessage;
  if (!hasDigit(password)) return PASSWORD_REQUIRE_DIGIT_MESSAGE;
  if (!hasSymbol(password)) return PASSWORD_REQUIRE_SYMBOL_MESSAGE;
  return null;
}

export const newPasswordRequirementsHint = `${MIN_NEW_PASSWORD_LENGTH}+ characters, one number, one symbol`;
